import { useLayoutEffect, useRef } from 'react';
import { getDeviceUuid } from '../api';
import { getScreenCacheContextRevision } from '../utils/localCache';
import { createNativeImageRequests } from '../utils/nativeImageRequests';

export default function useNativeImageRequests(scope) {
    const scopeRef = useRef(scope);
    const requests = useRef(null);
    if (!requests.current) requests.current = createNativeImageRequests(() =>
        JSON.stringify([scopeRef.current, getDeviceUuid(), getScreenCacheContextRevision()]));
    if (scopeRef.current !== scope) {
        requests.current.invalidate();
        scopeRef.current = scope;
    }
    useLayoutEffect(() => () => requests.current.invalidate(), []);
    return requests.current;
}
